import { render } from "./JobTemplate.vue?vue&type=template&id=6d826244&scoped=true"
import script from "./JobTemplate.vue?vue&type=script&lang=js"
export * from "./JobTemplate.vue?vue&type=script&lang=js"

import "./JobTemplate.vue?vue&type=style&index=0&id=6d826244&scoped=true&lang=css"
import "./JobTemplate.vue?vue&type=style&index=1&id=6d826244&lang=css"
script.render = render
script.__scopeId = "data-v-6d826244"

export default script